import { render, staticRenderFns } from "./WealthProductWithdrawCompleted.vue?vue&type=template&id=b64efb12&scoped=true"
import script from "./WealthProductWithdrawCompleted.vue?vue&type=script&lang=ts"
export * from "./WealthProductWithdrawCompleted.vue?vue&type=script&lang=ts"
import style0 from "./WealthProductWithdrawCompleted.vue?vue&type=style&index=0&id=b64efb12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64efb12",
  null
  
)

export default component.exports